<template>
  <div>
    <div
      class="card page mb-5 p-2"
      style="width: 1300px; margin: 0 auto; box-shadow: 10px 10px 5px #888888"
      id="v-content"
    >
      <p>
        <span
          class="float-right span_close"
          style="
            display: block;
            width: 20px;
            line-height: 20px;
            text-align: center;
            font-size: 25px;
          "
          @click="$router.go(-1)"
        >
          &times;
        </span>
      </p>
      <div style="margin: 0 auto; width: 1200px">
        <el-select
          v-model="bumenid"
          placeholder="请选择部门"
          @change="getPfListAll"
        >
          <el-option
            v-for="item in options"
            :key="item.bumen"
            :label="item.bumen"
            :value="item.bumenid"
          >
          </el-option>
        </el-select>
        <p style="margin-top:20px;color:red;text-align:right;">*0~1分为不称职，1~2分为基本称职，2~3分为称职，3~4分为优秀</p>
        <el-table :data="pjList" style="width: 100%; margin-top: 20px" border>
          <el-table-column
            prop="bumen"
            label="部门"
            width="180"
            header-align="center"
          >
          </el-table-column>
          <el-table-column
            prop="truename"
            label="姓名"
            width="120"
            align="center"
          >
          </el-table-column>
          <el-table-column prop="pjf" label="平均分" width="100" align="center">
            <template slot-scope="scope">
              <span>{{scope.row.pjf.toFixed(1)}}</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="cot"
            label="评价人数"
            width="100"
            align="center"
          >
          </el-table-column>
          <el-table-column prop="zjf" label="总计" width="120" align="center">
          </el-table-column>
          <el-table-column prop="one" label="不称职(总计)" width="120" align="center">
          </el-table-column>
          <el-table-column prop="two" label="基本称职(总计)" width="120" align="center">
          </el-table-column>
          <el-table-column prop="three" label="称职(总计)" width="100" align="center">
          </el-table-column>
          <el-table-column prop="four" label="优秀(总计)" width="100" align="center">
          </el-table-column>
          <el-table-column label="操作" align="center">
            <template slot-scope="scope">
              <el-button
                type="primary"
                size="mini"
                @click="checkDetail(scope.row)"
                >留言详情</el-button
              >
            </template>
          </el-table-column>
        </el-table>
        <el-dialog
          title="查看详情"
          :visible.sync="dialogDetail"
          :width="'1000px'"
          center
        >
          <div>
            <el-table :data="pjDetailList" style="width: 100%" border>
              <el-table-column
                prop="bumenname"
                label="部门名称"
                width="120"
                header-align="center"
              >
              </el-table-column>
              <el-table-column
                prop="truename"
                label="姓名"
                width="80"
                align="center"
              >
              </el-table-column>
              <el-table-column
                prop="jobs"
                label="职位"
                width="90"
                align="center"
              >
              </el-table-column>
              <el-table-column
                prop="pf"
                label="评分"
                width="180"
                header-align="center"
              >
                <template slot-scope="scope">
                  <div>
                    <el-rate
                      v-model="scope.row.pf"
                      show-text
                      :texts="texts"
                      :max="4"
                      disabled
                      :colors="colors"
                      text-color="red"
                    >
                    </el-rate>
                  </div>
                </template>
              </el-table-column>
              <el-table-column
                align="center"
                prop="adduser"
                label="评分人" width="90">
              </el-table-column>
              <el-table-column
                align="center"
                prop="inserttime"
                label="时间" width="110">
                <template slot-scope="scope">
                  <div>
                    {{scope.row.inserttime.split(" ")[0]}}
                  </div>
                </template>
              </el-table-column>
              <el-table-column
                prop="context"
                label="留言"
                header-align="center"
                show-overflow-tooltip
              >
              <template slot-scope="scope">
                <div>
                  {{scope.row.context?scope.row.context:'暂无留言'}}
                </div>
              </template>
              </el-table-column>
            </el-table>
          </div>
        </el-dialog>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      pjList: [],
      bumenid: "",
      options: [],
      texts: ["不称职", "基本称职", "称职", "优秀"],
      dialogDetail: false,
      pjDetailList: [],
      colors: ['#99A9BF', '#F7BA2A', '#FF9900']
    };
  },
  computed:{

  },
  components: {},
  methods: {
    getGs() {
      this.$http.post("Evaluate/GetGS", {}).then((res) => {
        if (res.data.isok) {
          this.options = [
            {
              bumen: "全部",
              bumenid: -1,
            },
            ...res.data.data,
          ];
        }
      });
    },
    getPfListAll() {
      let bumenid = this.bumenid ? this.bumenid : -1;
      this.$http
        .post("Evaluate/GetPjListAll", {
          bumenid,
        })
        .then((res) => {
          // console.log(res.data);
          this.pjList = res.data.data;
          // console.log(this.pjList)
        });
    },
    checkDetail(rows) {
      this.$http
        .post("Evaluate/GetPjListAllXq", {
          bumenid: rows.userid,
        })
        .then((res) => {
          if (res.data.isok) {
            this.pjDetailList = res.data.data;
            this.dialogDetail = true;
          }
        });
    },
  },
  created() {
    this.getGs();
    this.getPfListAll();
  },
};
</script>

<style scoped>
</style>





// WEBPACK FOOTER //
// src/pages/Pj/EvaluateAll.vue